import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Link } from "react-router-dom";
import styles from "./AppLink.less";
import cx from "classnames";
export function AppLink(props) {
  return React.createElement(Link, _extends({}, props, {
    className: cx(styles.AppLink, props.className, styles[props.type])
  }), props.text, props.children);
}